import { render, staticRenderFns } from "./MdtNotify.vue?vue&type=template&id=9e95e9d0&scoped=true"
import script from "./MdtNotify.vue?vue&type=script&lang=js"
export * from "./MdtNotify.vue?vue&type=script&lang=js"
import style0 from "./MdtNotify.vue?vue&type=style&index=0&id=9e95e9d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e95e9d0",
  null
  
)

export default component.exports